
<template>
  <div class="">
    <!-- 报价单预览页面 -->
    <el-form
      :status-icon="false"
      ref="fromFormat"
      :model="templateData"
      class="clearfix"
      :validate-on-rule-change="false"
      label-position="right"
      :rules="rules"
    >
      <el-dialog
        :title="$t('label.emailobject.templates')"
        ref="priceItem"
        :visible.sync="selectTemplateDialogVisible1"
        width="50%"
        top="300px"
        :close-on-click-modal="true"
        :before-close="handleClose"
        :lock-scroll="true"
      >
        <div class="mainContent">
          <el-form-item
            :label="$t('label.email.select.template')"
            label-width="30%"
            style="min-height: 38px; width: 100%"
            prop="templateId"
          >
            <el-select
              v-model="templateData.templateId"
              :placeholder="$t('label.searchs')"
              style="width: 60%"
              size="mini"
            >
              <el-option
                v-for="item in templateList"
                :key="item.templateid"
                :label="item.templatename"
                :value="item.templateid"
                :disabled="item.isenable !== '1'"
              >
                <!-- :disabled="item.isenable !== '1'" -->
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('c155', { name: title })"
            label-width="30%"
            style="min-height: 38px; width: 100%"
            prop="templateFile"
          >
            <el-input
              v-model="templateData.templateFile"
              style="width: 60%"
              size="mini"
            ></el-input>
          </el-form-item>
        </div>

        <div slot="footer" class="dialog-footer" style="text-align: right">
          <el-form-item class="btBox">
            <el-button size="mini" class="whiteBt" @click="handleClose">
              {{ $t("button_partner_cancel") }}
            </el-button>
            <el-button size="mini" type="primary" class="blueBt" @click="save">
              {{ $t("label.emailtocloudcc.button.sure") }}
            </el-button>
          </el-form-item>
        </div>
      </el-dialog>
    </el-form>
  </div>
</template>

<script>
/**
 * 报价单模板
 */
export default {
  components: {},
  data() {
    return {
      rules: {
        templateId: [
          {
            required: true,
            message: this.$i18n.t("label.ccdocument.select.template.open"),
            trigger: "blur",
          },
        ],
        templateFile: [
          {
            required: true,
            message: this.$i18n.t("label.weixin.input.filename"),
            trigger: "blur",
          },
        ],
      },
      templateData: {
        templateId: "",
        templateFile: "",
        templateType: "",
      },
    };
  },
  computed: {
    selectTemplateDialogVisible1() {
      return this.selectTemplateDialogVisible;
    },
  },
  props: {
    selectTemplateDialogVisible: {
      type: Boolean,
      default: true,
    },
    templateList: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
  },
  //方法集合
  methods: {
    init(fieldValue, id) {
      this.templateData.templateId = id;
      this.templateData.templateFile = fieldValue;
    },
    save() {
      this.$refs.fromFormat.validate((valid) => {
        if (valid) {
          this.$emit("closeSelectTemplateDialog", true, this.templateData);
        } else {
          return false;
        }
      });
    },
    handleClose() {
      this.$emit("closeSelectTemplateDialog");
    },
  },
};
</script>
<style lang='scss' scoped>
.mainContent {
  margin: 0px auto;
}
.btBox {
  margin-bottom: 0px;
}
</style>